import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'

const MainScreen: React.FC = () => {
    return (
      <Screen
        size="large"
        title={<span>Телефония, чаты и<br/>искусственный интеллект<br/>для бизнеса</span>}
        bottomLine={false}
      >
        <Styled.SubTitle>внедрим и настроим всё за вас</Styled.SubTitle>
        <Form
          free
          text='Попробовать сервис'
          pageName='Главная'
        />
      </Screen>
    )
}

export { MainScreen }